/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {createPOSLocalCashRedemption} from '../api'

export const useMutationCreatePOSLocalCashRedemption = createReactQueryMutationHook('createPOSLocalCashRedemption', createPOSLocalCashRedemption)
